<template>
<div>
    <div class="container mt_140">
    <ccMenu ref="cc_menu" v-bind:posicao=2></ccMenu>
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>
    <div class="row">
        <div class="col-12">
          <div class="row mb-3">
            <div class="col-2">
              <select class="form-control form-control-sm" v-model="frm_torneio_tipo" @change="filtro_tipo(frm_torneio_tipo)">
                <option value=0>Todos</option>
                <option value=1>Um contra o outro</option>
                <option value=2>Preço fixo</option>
                <option value=3>Torneios grátis</option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-control form-control-sm" v-model="frm_torneio_buy_in" @change="filtro_buy_in(frm_torneio_buy_in)">
                <option value="all">Valor de entrada</option>
                <option value="r1">0 - 5R$</option>
                <option value="r2">R$5 - R$30</option>
                <option value="r3">R$30 - R$100 </option>
                <option value="r4">R$100 - em diante  </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 pt-2" style="background: linear-gradient(rgba(255, 255, 255, 0.05) 0%, rgba(128, 128, 128, 0) 100%); min-height: 500px;">

              <div class="row">
                  <div class="col-md-8">
                      <div class="row pb-4">
                        <div class="col-md-2 text_branco text_bold">
                          TORNEIOS
                        </div>
                        <div class="col-3">
                          <router-link to="/meu_torneio/aguardando" class="btn btn-outline-success btn-sm w-100"> AGUARDANDO</router-link>
                        </div>
                        <div class="col-3">
                          <router-link to="/meu_torneio/andamento" class="btn btn-success btn-sm w-100"> EM ANDAMENTO </router-link>
                        </div>
                        <div class="col-3">
                          <router-link to="/meu_torneio/historico" class="btn btn-outline-success btn-sm w-100"> HISTÓRICO </router-link>
                        </div>
                      </div>
                  </div>
                </div>

                <div v-if="tor.length == 0" class="text_18 text_branco text-center pt-5">
                  Nenhum torneio acontecendo.<br>
                  Bora jogar! :)
                  <br> <br> <br> <br> <br>
                </div>

                <div v-if="tor.length > 0" v-for="t in tor" class="row mb-3">
                  <div class="col-md-12">
                    <div class="card text_branco p-2" @click="chamando_pagina_torneio(t.id)" style="text-decoration: none; cursor:pointer;">

                        <div v-if="t.torneio_tipo_id == 1 || t.torneio_tipo_id == 2 || t.torneio_tipo_id == 3">
                            <div class="row">
                              <div class="col-8">
                                <div class="text_17 text_bold text_branco" v-bind:class="[t.torneio_tipo_id==1?'text_roxo':t.torneio_tipo_id==2?'text_verde':'text_laranja']">
                                  {{t.torneio_nome}}
                                </div>
                                <div class="text_10 text_bold text_branco">{{t.tor_descricao_pagamento}}</div>
                              </div>
                              <div class="col-4 text_10 text_cinza text-end">
                                <div v-if="t.status>2" class="text_13 text_verde text_bold"> <span class="text_branco">GANHO:</span>
                                  <span v-bind:class="[t.prize>0?'text_verde':'text_vermelho']">R${{formatarMoeda(t.prize)}}</span>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12">
                                <div style="margin: 10px 10px 10px 0px; border-bottom:dashed #2F313C 2px;"></div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12 mb-2 text_10">
                                  <span v-bind:class="[t.torneio_tipo_id==1?'text_roxo':t.torneio_tipo_id==2?'text_verde':'text_laranja']">
                                    Tipo Torneio: {{torneio_tipo_nome(t.torneio_tipo_id)}}
                                  </span>
                              </div>
                              <div class="col-12 mb-2">
                                  <div class="text_10 text_bold text_branco">SUA POSIÇÃO: {{t.max_rank}}º </div>
                              </div>
                              <div class="col-3">
                                <div class="text_14 text_cinza">{{t.qtd_aposta}}/{{t.max_pessoa}}</div>
                                <div class="text_10">Entradas / Max</div>
                              </div>
                              <div class="col-3">
                                <div class="text_14 text_cinza">R$ {{t.taxa_entrada}}</div>
                                <div class="text_10">Entrada</div>
                              </div>
                              <div class="col-6">
                                <div class="text_10 text_amarelo text-end text_bold">Status: Acontecendo</div>
                                <div class="text_10 text_amarelo text-end">Previsão de Termino: {{t.dt_termino}}</div>
                              </div>
                            </div>
                        </div>

                        <div v-if="t.torneio_tipo_id == 4">
                            <div class="row">
                              <div class="col-12">
                                <div class="text_15 text_bold text_branco">
                                {{t.time1_nome}} x {{t.time2_nome}}
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="text_10 text_bold text_cinza">
                                  {{ t.mercado_escolhido >= 9 && t.mercado_escolhido <= 16 ? 'CANTO' : 'GOL' }}
                                  {{nomeMercadoEscolhido(t.mercado_escolhido)}}
                                </div>
                              </div>
                              <div class="col-6 text-end">
                                <div class="text_10 text_bold text_branco">
                                  <div v-if="t.status>2" class="text_13 text_verde text_bold"> <span class="text_cinza">GANHOS:</span>
                                    <span v-bind:class="[t.prize>0?'text_verde':'text_vermelho']">R${{formatarMoeda(t.prize)}}</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12">
                                <div style="margin: 5px 5px 5px 0px; border-bottom:dashed #2F313C 2px;"></div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-12 mb-2 text_10">
                                  <span style="color: aqua;">
                                    Tipo Torneio: {{torneio_tipo_nome(t.torneio_tipo_id)}}
                                  </span>
                              </div>
                              <div class="col-12 mb-2">
                                  <div class="text_10 text_bold text_branco">SUA POSIÇÃO: {{t.rank}}º </div>
                              </div>
                              <div class="col-3">
                                <div class="text_14 text_cinza">{{t.qtd_aposta}}/{{t.max_pessoa}}</div>
                                <div class="text_10">Entradas / Max</div>
                              </div>
                              <div class="col-3">
                                <div class="text_14 text_cinza">R$ {{t.taxa_entrada}}</div>
                                <div class="text_10">Entrada</div>
                              </div>
                              <div class="col-6">
                                <div class="text_10 text_cinza text-end text_bold">
                                  Status: <span class="text_verde">Acontecendo</span>
                                </div>
                                <div class="text_10 text_cinza text-end">Previsão de Término: {{t.dt_termino}}</div>
                              </div>
                            </div>
                        </div>


                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>
    </div>
    <ccFooter></ccFooter>
</div>
</template>

<script>
import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccFooter from '../layout/footer.vue'
import ccLoading from '../cc_geral/cc_loading.vue'

export default {
  data () {
    return {
      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //array
      orginal: [],
      tor: [],

      //filtro
      frm_torneio_tipo: 0,
      frm_torneio_buy_in: 'all',

      //paginação
      page: 1,
      page_ultimo: 0,

      //variaveis
      qtd_total_andamento: 0,
      timer_atualizar: null,
      timer_torneio_horario: null,
    }
  },

  components: {ccMenu, ccFooter, ccLoading},

  created(){
    document.title = 'Meus Torneios: Em andamento - SokkerDuel';
    localStorage.setItem("base_url_api_mobile", this.base_url_api);
  },

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
      this.expluse_para_login()
      return
    }else{
      this.user = a
    }

    this.get_meu_torneio(1)
    this.start_time()
    this.start_time_atualizar()
  },

  methods: {

    get_meu_torneio(loading_show = 0)
    {
      if(loading_show == 1) {
        //this.loading = true
      }

      var body = {
        user_id: this.user.id,
        tipo_id: this.frm_torneio_tipo,
        page: this.page,
        status: 1,
        buy_in: this.frm_torneio_buy_in,
      };

      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.post(this.base_url_api+'user/torneio/andamento',body, header)
      .then(response => {

        //receba todos os dados
        this.original = response.data.resp.data;

        this.qtd_total_andamento = this.orginal.length

        //atributos da paginacao vindo da consulta
        this.page_ultimo = response.data.resp.page_last

        this.higienizar_filtro()

        this.loading = false

        this.atualize_menu()
      })
      .catch(e => {
        this.errors.push(e);
        alert(e)
        this.expluse_para_login()
      });
    },


    higienizar_filtro(){

      let agora = Date.now()
      let seg = 0; let min = 0; let hora = 0; let dif = 0;
      let proximo = 999999999999999;

      var auxiliar = []
      var obj = {}
      this.tor = []
      var a = this.original
      this.tor = a

      //tipo ------------------------------------------------------------
      auxiliar = [];
      for (var i = 0; i <= a.length-1; i++) {
        if(a[i].tor_status == 2 || a[i].tor_status == 3){

          dif = ( (a[i].tor_dt_inicio_timestamp * 1000) - agora )
          dif = parseInt(dif/1000);

          obj = {
            id: a[i].tor_id,
            usuario_id: a[i].user_id,
            torneio_id: a[i].tor_id,
            rank: a[i].max_rank,
            // total_my_entrada: a[i].total_my_entrada,
            ganho: a[i].ganho_total,
            torneio_nome: a[i].tor_nome,
            dt_inicio_timestamp: a[i].tor_dt_inicio_timestamp,
            dt_termino: this.previsao_termino(a[i].tor_dt_termino_timestamp,3),
            status: a[i].tor_status,
            taxa_entrada: a[i].tor_taxa_entrada,
            torneio_tipo_id: a[i].tor_tipo_id,
            qtd_aposta: a[i].tor_qtd_aposta,
            prize: a[i].tor_prize,
            max_pessoa: a[i].tor_max_pessoa,
            tor_descricao_pagamento: a[i].tor_descricao_pagamento,
            dif: dif,
            time_regressivo: 0,
            max_rank: a[i].max_rank,
            prize: a[i].prize,
            fixture_id: a[i].jogo.id,
            mercado_escolhido: a[i].jogo.mercado_escolhido,
            time1_nome: a[i].jogo.time1_nome,
            time2_nome: a[i].jogo.time2_nome,
          }

          auxiliar.push(obj);
        }
      }
      this.tor = auxiliar

      //-------------------------------------------------------------

    },

    chamando_pagina_torneio(n){
      var self = this;
      self.$router.push({path: '/torneio/'+n});
    },

    filtro_tipo(tipo){
      this.frm_torneio_tipo = tipo
      this.get_meu_torneio(1)
    },

    filtro_buy_in(value){
      this.frm_torneio_buy_in = value
      this.get_meu_torneio(1)
    },

    expluse_para_login(){
      var self = this
      self.$router.push({path: '/login'});
    },

    start_time(){
      this.timer_torneio_horario = setInterval( function(){
        for (var i=0; i < this.tor.length; i++){
          this.tor[i].dif = this.tor[i].dif - 1;
          this.tor[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.tor[i].dif )
        }
      }.bind(this), 1000);
    },

    start_time_atualizar(){
      this.timer_atualizar = setInterval( function(){
          this.get_meu_torneio(0)
      }.bind(this), 60000);
    },

  },

  destroyed(){
    clearInterval(this.timer_torneio_horario);
    clearInterval(this.timer_atualizar);
  },

}
</script>

<style scoped>

  .form-control {
      color: #ffffff80;
      background-color: #333644;
      border: none;
  }

  .card{
    background: transparent linear-gradient(72deg, #FFFFFF00 0%, #80808033 100%) 0% 0% no-repeat padding-box;
    box-shadow: 3px 3px 8px #00000029;

  }

  .btn{
    font-size: 10px;
    border-radius: 5px;
    opacity: 1;
  }

  .btn_azul{
    color: #4968C1;
    border: 1px solid #5983F5;
  }

  .page-item{
    padding: 10px;
    background-color: transparent;
  }

  .page-link{
    background-color: transparent;
    text-decoration: none;
    font-size: 15px;
    font-family: bold;
    color: #cccccc;
    border: solid 1px #20222d;
  }

</style>



// WEBPACK FOOTER //
// src/components/meu/meu_torneio_andamento.vue